import client from "./client.js";

export async function fetchBillingPlans() {
  const res = await client.get("/billing/plans");
  return res.data.data;
}

export async function fetchBillingStatus() {
  const res = await client.get("/billing/status");
  return res.data.data;
}

export async function fetchBillingWorkspaces() {
  const res = await client.get("/billing/workspaces");
  return res.data.data;
}

export async function createCheckout(plan, interval = "monthly", workspaceId) {
  const res = await client.post("/billing/checkout", {
    plan,
    interval,
    workspace_id: workspaceId,
  });
  return res.data.data;
}

export async function getPaymentPortalUrl() {
  const res = await client.post("/billing/portal");
  return res.data.data;
}

export async function cancelSubscription() {
  await client.post("/billing/cancel");
}
